export enum FormFieldName {
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  StateOrProvince = 'StateOrProvince',
  PostalCode = 'PostalCode',
  Country = 'Country',
  JobTitle = 'JobTitle',
  Company = 'Company',
  Resume = 'Resume',
  PhoneNumber = 'PhoneNumber',
  Avatar = 'Avatar',
  Gender = 'Gender',
  Race = 'Race',
  LinkedIn = 'LinkedIn',
  MiddleName = 'MiddleName',
  AddressIsShared = 'AddressIsShared',
  Prefix = 'Prefix',
  Suffix = 'Suffix',
  TeamName = 'TeamName',
  TeamPublicName = 'TeamPublicName'
}
